module.exports = __webpack_public_path__ + "static/img/eshopPlatform.570c6be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eshopPlatform.png
// module id = T3z+
// module chunks = 1